export default __webpack_public_path__ + "static/media/Curiosity.3fb16c3a.png";